function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var BuildTemplate = require('./build.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var BuildOverlay = /*#__PURE__*/function () {
  function BuildOverlay(app, mod, c1, c2, c3) {
    _classCallCheck(this, BuildOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod, false, false, false);
    this.max_units = 1;
    this.units = 1;
    this.cost = 0;
    this.ops_available = 0;
    this.ops_spent = 0;
  }
  return _createClass(BuildOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.callback_on_close = null;
      this.overlay.hide();
      try {
        this.mod.available_units_overlay.hide();
      } catch (err) {
        console.log('error closing available units overlay...');
      }
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render(faction, unit, ops, cost, mycallback) {
      var _this = this;
      var his_self = this.mod;
      this.units = 1;
      this.cost = cost;
      this.ops_available = ops;
      this.ops_spent = cost;
      this.max_units = his_self.returnNumberOfUnitsAvailableForConstruction(faction, unit);
      var max_buildable_units = ops / cost;

      //
      // if we cannot possibly build more than 1 unit, do not show the
      // UI overlay intended to save us time in building multiple units
      //
      if (cost * 2 > this.ops_available) {
        return;
      }
      this.overlay.show(BuildTemplate());
      this.overlay.callback_on_close = function () {
        _this.hide();
      };
      if (unit === 'mercenary') {
        document.querySelector('.unit-details').style.backgroundImage = 'linear-gradient(rgba(0, 0, 0, 0.527),rgba(0, 0, 0, 0.5)) , url(/his/img/backgrounds/move/mercenary.jpg)';
      }
      if (unit === 'cavalry') {
        document.querySelector('.unit-details').style.backgroundImage = 'linear-gradient(rgba(0, 0, 0, 0.527),rgba(0, 0, 0, 0.5)) , url(/his/img/backgrounds/move/cavalry.jpg)';
      }
      if (unit === 'corsair') {
        document.querySelector('.unit-details').style.backgroundImage = 'linear-gradient(rgba(0, 0, 0, 0.527),rgba(0, 0, 0, 0.5)) , url(/his/img/backgrounds/move/corsair.jpg)';
      }
      if (unit === 'squadron') {
        document.querySelector('.unit-details').style.backgroundImage = 'linear-gradient(rgba(0, 0, 0, 0.527),rgba(0, 0, 0, 0.5)) , url(/his/img/backgrounds/move/squadron.jpg)';
      }
      this.mod.available_units_overlay.hide();
      this.mod.available_units_overlay.renderBuild(faction, unit, ops, cost, function (num) {
        _this.hide();
        mycallback(num, _this.cost);
      });
      this.attachEvents(faction, unit, ops, cost, mycallback);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(faction, unit, ops, cost, mycallback) {
      var _this2 = this;
      document.querySelector('.fewer-units').onclick = function (e) {
        if (_this2.units == 1) {
          alert('cannot produce less than one unit');
          return;
        }
        _this2.units--;
        _this2.ops_spent = _this2.ops_available - _this2.cost * _this2.units;
        document.querySelector('.unit-details').innerHTML = _this2.units;
      };
      document.querySelector('.more-units').onclick = function (e) {
        if (_this2.ops_available < _this2.cost * (_this2.units + 1)) {
          alert('not enough OPs to produce more');
          return;
        }
        if (_this2.max_units <= _this2.units) {
          alert('at unit production limit...');
          return;
        }
        _this2.units++;
        _this2.ops_spent = _this2.ops_available - _this2.cost * _this2.units;
        document.querySelector('.unit-details').innerHTML = _this2.units;
      };
      document.querySelector('.build-submit').onclick = function (e) {
        _this2.hide();
        mycallback(_this2.units, _this2.cost);
      };
    }
  }]);
}();
module.exports = BuildOverlay;